import {NonprofitCard} from 'src/components/widget/components/NonprofitInfo/NonprofitCard';

export const NonprofitInfo = () => {
	return <NonprofitCard />;
};
